import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function PainPoints() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <section className="py-8 md:py-12 bg-white relative" data-id="element-226">
      <div className="max-w-3xl mx-auto px-6" data-id="element-227">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={containerVariants} className="space-y-10" data-id="element-228">
          <motion.div variants={itemVariants} className="text-center mb-12" data-id="element-229">
            <h2 className="text-3xl md:text-4xl font-serif text-[#2d2d2d] mb-6" data-id="element-230">
              Querida amiga,
            </h2>
            <p className="text-lg md:text-xl text-[#5a5a5a] leading-relaxed" data-id="element-231">
              Quiero que te detengas un momento. Respira profundo. Ahora escucha
              esta pregunta:
            </p>
            <p className="text-2xl md:text-3xl font-serif text-[#9d4b6b] italic mt-8 font-medium" data-id="element-232">
              ¿Alguna vez has sentido que tu matrimonio sigue vivo… pero el amor
              ya no?
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="prose prose-lg mx-auto text-[#5a5a5a]" data-id="element-233">
            <p data-id="element-234">
              Quizás duermes junto a tu esposo, lo escuchas respirar, puedes
              extender la mano y tocarlo… pero emocionalmente está a kilómetros
              de distancia.
            </p>
            <p data-id="element-235">Y lo peor es que lo amas. Lo amas tanto que duele.</p>
            <p data-id="element-236">
              No hablas con nadie de esto. No quieres preocupar a tu familia. No
              quieres escuchar el típico "aguanta, así son los matrimonios". No
              quieres sentirte juzgada por buscar tu propia felicidad.
            </p>
            <p className="font-medium text-[#2d2d2d]" data-id="element-237">
              Pero la verdad es que estás cansada. Cansada del silencio. Cansada
              de sentirte ignorada. Cansada de preguntarte todas las noches:
              "¿Por qué ya no somos como antes?"
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-[#faf8f6] p-8 md:p-10 rounded-2xl border border-[#d4a5a5]/30 my-10" data-id="element-238">
            <h3 className="text-2xl md:text-3xl font-serif text-[#9d4b6b] mb-6" data-id="element-239">
              Cuando un matrimonio se vuelve rutina… el corazón empieza a
              apagarse
            </h3>
            <p className="mb-6" data-id="element-240">
              Hace unos años, despertabas con ilusión. Te arreglabas y él te
              miraba como si fueras lo más hermoso del mundo. Había risas en la
              cocina. Había complicidad. Había mariposas.
            </p>
            <p className="mb-6" data-id="element-241">
              Hoy, en cambio, las conversaciones son transacciones domésticas:
            </p>
            <ul className="space-y-3 mb-8 ml-4" data-id="element-242">
              <li className="flex items-center text-[#5a5a5a]" data-id="element-243">
                <span className="w-2 h-2 bg-[#9d4b6b] rounded-full mr-3" data-id="element-244"></span>
                ¿Quién recoge a los niños?
              </li>
              <li className="flex items-center text-[#5a5a5a]" data-id="element-245">
                <span className="w-2 h-2 bg-[#9d4b6b] rounded-full mr-3" data-id="element-246"></span>
                ¿Pagaste la luz?
              </li>
              <li className="flex items-center text-[#5a5a5a]" data-id="element-247">
                <span className="w-2 h-2 bg-[#9d4b6b] rounded-full mr-3" data-id="element-248"></span>
                ¿Qué cenamos?
              </li>
            </ul>
            <p className="font-medium text-[#2d2d2d]" data-id="element-249">
              Y esa distancia emocional te está rompiendo por dentro.
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="text-center py-6" data-id="element-250">
            <p className="text-[#5a5a5a] mb-4 italic" data-id="element-251">
              Si sientes que esta historia es la tuya, hay un camino de
              regreso...
            </p>
            <CTAButton className="text-base" data-id="element-252">
              Descubre el Método Completo
            </CTAButton>
          </motion.div>

          <motion.div variants={itemVariants} className="space-y-6" data-id="element-253">
            <p className="text-lg italic text-[#8b6f6f] border-l-4 border-[#d4a5a5] pl-6 py-2" data-id="element-254">
              Quizás te has sorprendido mirando a parejas felices en redes
              sociales, preguntándote: "¿Por qué ellos sí y nosotros no?"
            </p>
            <p data-id="element-255">
              No es envidia. Es nostalgia. Nostalgia por lo que tú también
              mereces: atención, cariño, admiración, ternura.
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="pt-6" data-id="element-256">
            <h3 className="text-2xl md:text-3xl font-serif text-[#2d2d2d] mb-6" data-id="element-257">
              El dolor oculto que no te atreves a decir
            </h3>
            <p className="mb-4" data-id="element-258">
              Te duele que él ya no te busque como antes. Te duele que no
              pregunte cómo estás realmente. Te duele que la pasión se haya
              convertido en silencio.
            </p>
            <p className="mb-4" data-id="element-259">
              Tal vez hasta has sospechado que existe otra mujer. O peor aún…
              que ya no formas parte de sus sueños.
            </p>
            <p className="mb-8" data-id="element-260">
              Y sin embargo, sigues ahí. Creyendo que un día, sin saber cómo,
              todo volverá a la normalidad.
            </p>
            <p className="text-xl font-medium text-[#9d4b6b] text-center" data-id="element-261">
              Pero en tu interior sabes algo: si no haces nada, la distancia
              seguirá creciendo. Y ese miedo callado es lo que te trajo aquí.
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}